import React, { useEffect, useRef, useState } from "react";
import { decryptData, formatDateNewYYYYMMDD, formatDateYYYYMMDD, handleAlphaSpaceChange, handleAlphaSpacePaste, isPasswordProtectedPdf, sanitizeDropdownInput, validateFile } from "../../../CommonMethhods/CommonMethods";
import axiosInstance, { axiosFormDataInstance } from "../../../CommonMethhods/axiosInstance";
import { Dealer_Mapping } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import fileIcon from "../../../asset/images/file-withbg.svg";
import attachIcon from "../../../asset/images/attach.svg";
import closeIcon from "../../../asset/images/close-gray.svg";
import uploadIcon from "../../../asset/images/upload-file.svg";
import arrowIcon from "../../../asset/images/gray-arrow.svg";
import viewIcon from "../../../asset/images/view-eyes.svg";
import downloadIcon from "../../../asset/images/download-brokrage.svg";
import CommonModal from "../../../Components/Common/CommonModal/CommonModal";
import { Controller, useForm } from "react-hook-form";
import SmallLoader from "../../../Components/Common/smallLoader";
import { useDebounce } from "../../../Components/useDebounce";
import SearchDropdown from "../../../CommonMethhods/searchDropdown";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import moment from "moment";

// // The dates the backend stamps on the mapping. They only exist once the
// // checker has acted, so they read as "-" until then.
// const dateLogicValue = (value) => {
  // if (!value) return "-";

  // const parsed = moment(value);
  // if (!parsed.isValid()) return "-";

  // return String(value).includes(":")
    // ? parsed.format("DD-MM-YYYY hh:mm A")
    // : parsed.format("DD-MM-YYYY");
// };

function NewMappingReq({ selectedRequest, isFromMyRequest, setSelectedSR, refreshHistory, rowData, isReadOnly,
  setActiveTab, setShowConfirmation, setConfirmationData }) {
  const [submitLoader, setSubmitLoader] = useState(false);
  const [draftLoader, setDraftLoader] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [searchClCode, setSearchClCode] = useState("");
  const [clError, setClError] = useState("");
  const [clLoader, setClLoader] = useState(false);
  const [dealerList, setDealerList] = useState([]);
  const [showDealerDropdown, setShowDealerDropdown] = useState(false);
  const [searchDlCode, setSearchDlCode] = useState("");
  const [dlError, setDlError] = useState("");
  const [dlLoader, setDlLoader] = useState(false);
  // // Old dealer is only captured on the draft details screen. It carries over
  // // whatever the maker picked when the draft was saved, and stays editable so
  // // it can be filled in here when the draft was saved without it.
  // const [oldDealerList, setOldDealerList] = useState([]);
  // const [showOldDealerDropdown, setShowOldDealerDropdown] = useState(false);
  // const [searchOldDlCode, setSearchOldDlCode] = useState("");
  // const [oldDlError, setOldDlError] = useState("");
  // const [oldDlLoader, setOldDlLoader] = useState(false);
  const debouncedValue = useDebounce(searchClCode, 1000);
  const debouncedDlValue = useDebounce(searchDlCode, 1000);
  // const debouncedOldDlValue = useDebounce(searchOldDlCode, 1000);
  const [approvalDocLink, setApprovalDocLink] = useState("");
  const [activeMapping, setActiveMapping] = useState(null);
  const [activeMappingLoader, setActiveMappingLoader] = useState(false);
  // Submit runs through a confirmation popup - the validated values are held
  // here until the maker confirms.
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmValues, setConfirmValues] = useState(null);
  const [clientName, setClientName] = useState("");
  const [dealerName, setDealerName] = useState("");
  const [oldDealerName, setOldDealerName] = useState("");

  // A reopened draft / sent back request keeps the effective date it was saved
  // with. That date may have passed by now, and it must not stop the request
  // being submitted again when the maker has not touched it.
  const savedEffectiveDate =
    isFromMyRequest && rowData?.requests?.[0]?.startDate
      ? moment(rowData.requests[0].startDate, "YYYY-MM-DD").format("DD-MM-YYYY")
      : "";

  // Same for the remarks: ones saved before the minimum length existed must
  // not block resubmitting a request nobody has edited.
  const savedRemarks =
    isFromMyRequest ? (rowData?.requests?.[0]?.remarks || "").trim() : "";

  const newMappingValidation = Yup.object().shape({
    clientCode: Yup.string()
      .required("UCC / Client Code is required"),

    dealerCode: Yup.string()
      .required("New Dealer Code/Name is required"),

    // // A new mapping has no prior dealer, so the backend rejects this when
    // // filled; an update to an existing mapping needs it (the backend also
    // // rejects a blank old dealer code once an active mapping exists).
    // oldDealerCode: Yup.string().when("reasonType", {
      // is: "newMapping",
      // then: (schema) =>
        // schema.max(0, "Old Dealer Code should be blank for a new mapping"),
      // otherwise: (schema) =>
        // schema.when("reasonType", {
          // is: "updateMapping",
          // then: (s) => s.required("Old Dealer Code is required"),
          // otherwise: (s) => s.notRequired(),
        // }),

    effectiveDate: Yup.string()
      .required("Effective Date is required")
      .test(
        "valid-date",
        "Please enter a valid date",
        value => moment(value, "DD-MM-YYYY", true).isValid()
      )
      .test(
        "future-date",
        "Effective Date cannot be before the request date",
        // value =>
        //   moment(value, "DD-MM-YYYY").isSameOrAfter(moment(), "day")
        value =>
          (!!savedEffectiveDate && value === savedEffectiveDate) ||
          moment(value, "DD-MM-YYYY").isSameOrAfter(moment(), "day")
      ),

    reasonType: Yup.string()
      .required("Reason Type is required"),

    // reason: Yup.string().when("reasonType", {
      // is: "others",
      // then: (schema) =>
        // schema
          // .required("Reason is required")
          // .min(10, "Reason must be at least 10 characters")
          // .max(500, "Reason cannot exceed 500 characters"),
      // otherwise: (schema) => schema.notRequired(),
    // }),

    remarks: Yup.string()
      .trim()
      .required("Remarks is required")
      .max(500, "Remarks cannot exceed 500 characters")
      // .when("reasonType", {
      //   is: "others",
      //   then: (schema) =>
      //     schema.min(10, "Remarks must be at least 10 characters"),
      // }),
      // .min(10, "Remarks must be at least 10 characters"),
      .test(
        "min-length",
        "Remarks must be at least 10 characters",
        (value) =>
          (!!savedRemarks && value === savedRemarks) ||
          (value || "").length >= 10
      ),

    approvalDoc: Yup.mixed()
      .required("Approval document is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    clearErrors,
    formState: { errors, isValid }
  } = useForm({
    resolver: yupResolver(newMappingValidation),
    mode: "onChange",
    defaultValues: {
      clientCode: "",
      dealerCode: "",
      oldDealerCode: "",
      effectiveDate: null,
      reasonType: "",
      reason: "",
      remarks: "",
      approvalDoc: null,
      branch: ""
    }
  });
  const reasonOptions = [
    "newMapping",
    "updateMapping",
    "others"
  ];
  const buttonRefs = useRef([]);
  const reasonRefs = useRef([]);
  // const reasonTextareaRef = useRef(null);

  const branch = watch("branch");
  // const reasonText = watch("reason") || "";
  const remarksText = watch("remarks") || "";
  const selectedReasonType = watch("reasonType");

  // const reasonLength = reasonText.trim().length;
  const remarksLength = remarksText.trim().length;

  // const pendingMinChars = Math.max(0, 10 - reasonLength);
  // const remainingChars = 500 - reasonLength;

  // Remarks are the only explanation a maker gives for any reason type, so
  // they need a minimum length whichever type is picked.
  // const pendingMinChars =
  //   selectedReasonType === "others" ? Math.max(0, 10 - remarksLength) : 0;
  // const pendingMinChars = Math.max(0, 10 - remarksLength);
  const pendingMinChars =
    savedRemarks && remarksText.trim() === savedRemarks
      ? 0
      : Math.max(0, 10 - remarksLength);
  // The minimum-length message only appears once the maker starts typing; an
  // empty box gets "Remarks is required" instead, never both together.
  const showMinCharsMsg = remarksLength > 0 && pendingMinChars > 0;
  const remainingRemarkChars = 500 - remarksText.length;

  const watchedValues = watch();

  const canSaveDraft = [
    watchedValues?.approvalDoc,
    watchedValues?.clientCode,
    watchedValues?.dealerCode,
    watchedValues?.effectiveDate,
  ].every((value) => (typeof value === "string" ? value.trim() : value));

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const fetchActiveMapping = async (ucc) => {
    if (!ucc) {
      setActiveMapping(null);
      return;
    }

    setActiveMappingLoader(true);

    try {
      const response = await axiosInstance.get(
        `${Dealer_Mapping.activeMapping}/${ucc}`
      );

      const decrypted = JSON.parse(decryptData(response?.data));

      if (decrypted?.status === 0) {
        // data is null when the client simply has no active mapping - that is a
        // valid answer, not a failure.
        const mapping = decrypted?.data;
        const currentDealer = mapping?.dealerCode || null;

        setActiveMapping(currentDealer);

        // // Prefill Old Dealer Code/Name with the client's current mapping; it
        // // stays editable. dealerName is display enrichment and can come back
        // // empty, so the code alone drives the field. Skipped for New Mapping,
        // // where the backend requires this field to stay blank.
        // if (currentDealer && selectedReasonType !== "newMapping") {
          // setOldDealerName(mapping?.dealerName || "");
          // setSearchOldDlCode(currentDealer);
          // setValue("oldDealerCode", currentDealer, { shouldDirty: true });
        // } else {
          // setOldDealerName("");
        // }

        // The old dealer is simply the client's current mapping, read straight
        // from the DB whatever the reason type; it is blank when there is none.
        setOldDealerName(mapping?.dealerName || "");
        setValue("oldDealerCode", currentDealer || "", { shouldDirty: true });

        // The mapping carries the branch too; the client dropdown value stays
        // as the fallback when it comes back empty.
        if (mapping?.branch) {
          setValue("branch", mapping.branch, { shouldValidate: true });
        }
      } else {
        setActiveMapping(null);
        setOldDealerName("");
        toast.error(decrypted?.message);
      }
    } catch (error) {
      // No mapping now comes back as status 0 with data null, so reaching here
      // means the lookup itself failed and the maker should know.
      setActiveMapping(null);
      setOldDealerName("");
      console.log(error);
      toast.error("Could not check the current dealer mapping. Please retry.");
    } finally {
      setActiveMappingLoader(false);
    }
  };

  const submitSingleMapData = async (formValues, isDraft = false) => {
    if (isDraft) {
      setDraftLoader(true);
    } else {
      setSubmitLoader(true);
    }

    const finalReason =
      formValues.reasonType === "newMapping"
        ? "New mapping"
        : formValues.reasonType === "updateMapping"
          ? "Update existing mapping"
          // : formValues.reason;
          : formValues.reasonType === "others"
            ? "Others"
            : "";

    const formData = new FormData();
    // A draft can be saved partially filled, so only what the maker actually
    // entered is sent - empty values would reach the API as "undefined".
    const appendValue = (key, value) => {
      if (value === undefined || value === null || value === "") return;
      formData.append(key, value);
    };

    appendValue("client-code", formValues.clientCode);
    appendValue("new-dealer-code", formValues.dealerCode);
    // // Optional: when omitted the backend falls back to the client's current
    // // mapping, which is the behaviour that predates this field.
    // appendValue("old-dealer-code", formValues.oldDealerCode);
    // // old-dealer-code is deliberately not sent: the backend takes it from the
    // // client's current mapping itself.
    // The dealer read from the DB is sent, as it was before the field became
    // read-only; a draft with only a client code was rejected without it. A
    // new mapping is the exception: the backend requires it blank there.
    if (formValues.reasonType !== "newMapping") {
      appendValue("old-dealer-code", formValues.oldDealerCode);
    }
    appendValue("effective-date", formatDateNewYYYYMMDD(formValues.effectiveDate));
    appendValue("reason", finalReason);
    appendValue("remarks", formValues.remarks);
    appendValue("branch", formValues.branch);
    appendValue("approval-doc", formValues.approvalDoc);

    try {

      let url = "";
      let getDetails;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${selectedRequest?.batchId}/submit?draft=${isDraft}`;

        getDetails = await axiosFormDataInstance.put(url, formData);
      } else {
        url = `${Dealer_Mapping.singleMappingSubmit}/submit${isDraft ? "?draft=true" : ""
          }`;

        getDetails = await axiosFormDataInstance.post(url, formData);
      }

      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );
      console.log(decrypted, "viewTable");
      if (decrypted?.status === 0) {
        // A draft is saved even when the rows are still incomplete, so it always
        // lands on the confirmation screen.
        const isValidRequest =
          isDraft ||
          decrypted?.data?.validityStatus?.toLowerCase() === "valid";

        if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else if (isValidRequest) {
          setConfirmationData({
            ...decrypted?.data,
            type: isDraft ? "draft" : "submit",
          });
          setShowConfirmation(true);
        }

        if (isValidRequest) {
          // The backend's message for a draft reads like a new request was
          // created, so it gets its own wording.
          toast.success(isDraft ? "Saved as draft" : decrypted?.message);
        } else {
          toast.error(decrypted?.data?.failures?.[0] || decrypted?.message);
        }

      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      const catchResp = JSON.parse(
        decryptData(error?.response?.data)
      );
      console.log(error, catchResp,"catchResp");
      toast.error(catchResp?.message)

    } finally {
      if (isDraft) {
        setDraftLoader(false);
      } else {
        setSubmitLoader(false);
      }
    }
  };

  // Submit asks for confirmation first; the API call happens on Confirm.
  const onSubmit = (data) => {
    setConfirmValues(data);
    setConfirmModal(true);
  };

  const handleConfirmSubmit = () => {
    setConfirmModal(false);
    submitSingleMapData(confirmValues, false);
  };

  // useEffect(() => {
    // if (selectedReasonType === "others") {
      // setTimeout(() => {
        // reasonTextareaRef.current?.focus();
      // }, 0);
    // }
  // }, [selectedReasonType]);

  // Remarks are written for one reason type, so picking another starts them
  // afresh. Done in the radio's change handler rather than an effect so that
  // loading a draft, which sets the type programmatically, keeps its remarks.
  const reasonTypeField = register("reasonType");
  const handleReasonTypeChange = (e) => {
    setValue("remarks", "", { shouldDirty: true });
    clearErrors("remarks");
    reasonTypeField.onChange(e);
  };

  // A draft is saved with whatever has been filled in so far, so it skips
  // the form validation the submit flow runs through.
  const onSaveDraft = () => {
    submitSingleMapData(getValues(), true);
  };

  useEffect(() => {
    if (!isFromMyRequest || !rowData?.requests?.length) 
    return;

    const request = rowData.requests[0];
    setSearchClCode(request.ucc || "");
    setSearchDlCode(request.newDealerCode || "");
    // // Blank when the draft was saved before an old dealer was picked - the
    // // field stays open so it can be chosen here.
    // setSearchOldDlCode(request.oldDealerCode || "");

    setValue("clientCode", request.ucc || "", {
      shouldValidate: true,
    });

    setValue("dealerCode", request.newDealerCode || "", {
      shouldValidate: true,
    });

    setValue("oldDealerCode", request.oldDealerCode || "");
    // Drafts are editable and the client's mapping may have changed since the
    // draft was saved, so the old dealer is looked up afresh.
    if (!isReadOnly) fetchActiveMapping(request.ucc);

    setValue("branch", request.branch || "");
    setValue(
      "effectiveDate",
      request.startDate
        ? moment(request.startDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        : ""
    );

    // setValue(
    //   "effectiveDate",
    //   request.startDate
    //     ? new Date(request.startDate).toISOString().split("T")[0]
    //     : ""
    // );
    // let reasonType = "others";
    // A draft can be saved before any reason type was chosen.
    let reasonType = request.reason ? "others" : "";

    if (request.reason === "New mapping") {
      reasonType = "newMapping";
    } else if (request.reason === "Update existing mapping") {
      reasonType = "updateMapping";
    }

    setValue("reasonType", reasonType);

    if (reasonType === "others") {
      setValue("reason", request.reason || "");
    } else {
      setValue("reason", "");
    }

    setValue("remarks", request.remarks || "", { shouldValidate: true });
    setClientName(request.clientName || "");
    setDealerName(request.newDealerName || "");
    setOldDealerName(request.oldDealerName || "");
    setApprovalDocLink(rowData.approvalDocLink || "");
    setValue(
      "approvalDoc",
      rowData.approvalDocLink || "existing-file",
      {
        shouldValidate: true,
      }
    );

  }, [rowData, isFromMyRequest, setValue]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!validateFile(file)) {
      e.target.value = "";
      return;
    }
    // The backend validates the picked file (e.g. password-protected PDF) and its
    // message is shown as-is; the file is rejected when it reports a failure.
    // if (await isPasswordProtectedPdf(file)) {
    //   toast.error("The uploaded file is password protected. Please upload a file without a password.");
    //   e.target.value = "";
    //   return;
    // }
    try {
      const fileData = new FormData();
      fileData.append("approval-doc", file);
      const validateResp = await axiosFormDataInstance.post(Dealer_Mapping.validateApprovalDoc, fileData);
      const validated = JSON.parse(decryptData(validateResp?.data));
      if (validated?.status !== 0) {
        toast.error(validated?.message);
        e.target.value = "";
        return;
      }
    } catch (error) {
      let catchResp = null;
      try {
        catchResp = JSON.parse(decryptData(error?.response?.data));
      } catch (parseError) {
        catchResp = null;
      }
      if (catchResp?.message) {
        toast.error(catchResp.message);
        e.target.value = "";
        return;
      }
      // No usable backend response: let the file through, submit validates it again.
    }
    setUploadedFile(file);
    setValue("approvalDoc", file, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const fetchDropdownData = async ({
    url,
    searchText,
    setLoader,
    setList,
    setError
  }) => {
    setLoader(true);
    setError("");

    try {
      const response = await axiosInstance.get(
        `${Dealer_Mapping.clientCodeList}/${url}?prefix=${searchText}`
      );

      const decrypted = JSON.parse(
        decryptData(response?.data)
      );

      if (decrypted?.status === 0) {
        setList(decrypted?.data || []);
      } else {
        setList([]);
        setError(decrypted?.message);
      }

    } catch (error) {
      console.log(error);
      setList([]);
    } finally {
      setLoader(false);
    }
  };

  // useEffect(() => {
    // if (selectedReasonType !== "newMapping") return;

    // setSearchOldDlCode("");
    // setOldDealerName("");
    // setValue("oldDealerCode", "", { shouldDirty: true, shouldValidate: true });
  // }, [selectedReasonType]);

  useEffect(() => {
    if (!debouncedValue) return;

    fetchDropdownData({
      url: "clients",
      searchText: debouncedValue,
      setLoader: setClLoader,
      setList: setClientList,
      setError: setClError
    });
  }, [debouncedValue]);

  useEffect(() => {
    if (!debouncedDlValue) return;

    fetchDropdownData({
      url: "dealers",
      searchText: debouncedDlValue,
      setLoader: setDlLoader,
      setList: setDealerList,
      setError: setDlError
    });
  }, [debouncedDlValue]);

  // useEffect(() => {
    // if (!debouncedOldDlValue) return;

    // fetchDropdownData({
      // url: "dealers",
      // searchText: debouncedOldDlValue,
      // setLoader: setOldDlLoader,
      // setList: setOldDealerList,
      // setError: setOldDlError
    // });
  // }, [debouncedOldDlValue]);

  // const isReasonValid =
    // selectedReasonType !== "others" || reasonLength >= 10;

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();

    if (isReadOnly) return;

    const file = e.dataTransfer.files[0];

    if (!file) return;

    // Reuse your existing handler
    handleFileChange({
      target: {
        files: [file],
        value: "",
      },
    });
  };

  const handlePreviewFile = () => {
    if (uploadedFile) {
      const fileUrl = URL.createObjectURL(uploadedFile);
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      return;
    }

    if (approvalDocLink) {
      window.open(approvalDocLink, "_blank", "noopener,noreferrer");
    }
  };

  const handleDownloadFile = () => {
    if (uploadedFile) {
      const fileUrl = URL.createObjectURL(uploadedFile);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = uploadedFile.name;
      link.click();
      setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
      return;
    }

    if (approvalDocLink) {
      window.open(approvalDocLink, "_self", "noopener,noreferrer");
    }
  };

  // const mappingRequest = rowData?.requests?.[0];

  // // The new dealer starts on the effective date the maker picked, so the preview
  // // tracks that field live and falls back to the stored value.
  // const pickedEffectiveDate = watchedValues?.effectiveDate;

  // const newDealerStartDate = moment(
    // pickedEffectiveDate,
    // "DD-MM-YYYY",
    // true
  // ).isValid()
    // ? pickedEffectiveDate
    // : dateLogicValue(mappingRequest?.startDate);

  // const dateLogicRules = [
    // {
      // // Always present as a key, but empty until the business rule behind it is
      // // settled, so this reads "-" for now.
      // label: "OLD DEALER END DATE",
      // value: dateLogicValue(mappingRequest?.oldDealerEndDate),
    // },
    // {
      // label: "NEW DEALER START DATE",
      // value: newDealerStartDate,
    // },
  // ];

  // Values shown in the confirmation popup
  const confirmDocName = uploadedFile?.name || rowData?.approvalDocFilename || "";

  const confirmReason =
    confirmValues?.reasonType === "newMapping"
      ? "New mapping"
      : confirmValues?.reasonType === "updateMapping"
        ? "Update existing mapping"
        // : confirmValues?.reason || "-";
        : "Others";

  // The draft "View Details" screen arranges the same fields differently and
  // adds the old dealer, so the shared ones are defined once and placed below.
  const effectiveDateField = (
    <div className="internal-section enable-input">
      <label className="section-label">Effective Date <span className="error-mark">*</span></label>
      <Controller
        name="effectiveDate"
        control={control}
        render={({ field }) => (
          <CustomTradeDate
            idPrefix="effectiveDate"
            value={field.value || ""}
            onChange={field.onChange}
            disabled={isReadOnly}
          />
        )}
      />

      {errors.effectiveDate && (
        <span className="ErrorMsg">
          {errors.effectiveDate.message}
        </span>
      )}
    </div>
  );

  const oldDealerLabel = (code, name) =>
    code ? (name ? `${code} ${name}` : code) : "NA";

  const oldDealerField = (
    <div className="internal-section">
      <label className="section-label">Old Dealer Code/Name</label>

      {/*
      <SearchDropdown
        value={searchOldDlCode}
        placeholder="Enter Old Dealer Code/Name"
        showDropdown={showOldDealerDropdown}
        setShowDropdown={setShowOldDealerDropdown}
        data={oldDealerList}
        loading={oldDlLoader}
        error={oldDlError}
        onInputChange={(e) => {
          const value = sanitizeDropdownInput(e, {
            allowSpace: true,
            maxLength: 50
          });

          setSearchOldDlCode(value);
          setValue("oldDealerCode", value, {
            shouldDirty: true,
          });
          setOldDealerName("");
          setShowOldDealerDropdown(true);

          if (!value) {
            setOldDealerList([]);
            setOldDlError("");
            setShowOldDealerDropdown(false);
          }
        }}
        onSelect={(item) => {
          setSearchOldDlCode(item?.dealerCode);
          setValue("oldDealerCode", item?.dealerCode, {
            shouldDirty: true,
          });
          setOldDealerName(item?.dealerName || "");
          setShowOldDealerDropdown(false);
        }}
        disabled={isReadOnly || selectedReasonType === "newMapping"}
      />

      {errors.oldDealerCode && (
        <span className="ErrorMsg">
          {errors.oldDealerCode.message}
        </span>
      )}
      */}

      <input
        className="section-input"
        type="text"
        disabled
        value={oldDealerLabel(watchedValues?.oldDealerCode, oldDealerName)}
        readOnly
      />
    </div>
  );

  const handleButtonKeyDown = (e, index) => {
    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        if (index < buttonRefs.current.length - 1) {
          buttonRefs.current[index + 1]?.focus();
        }
        break;

      case "ArrowLeft":
        e.preventDefault();
        if (index > 0) {
          buttonRefs.current[index - 1]?.focus();
        }
        break;

      case "Enter":
      case " ":
        e.preventDefault();
        e.currentTarget.click();
        break;

      default:
        break;
    }
  };

  return (
    <div className="card-tab-details">
      <div className="dealer-mapping-main">
        <div className="ckr-page">
          <div className="info-banner info-flex">
            <div className="wrap-infoicon">
              <img src={fileIcon} alt="file icon" />
            </div>
            <span className="banner-text">
              <span className="bold-text">For multiple records use Bulk Upload</span>{" "}
              On submission, Checker receives an email notification automatically.
            </span>
          </div>

          <div className="ckr-section">
            <div className="draft-header">
              {selectedRequest?.batchId ?
                <div className="status-content">
                  <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                  {selectedRequest?.status !== "" ?
                    <span
                      className={`${selectedRequest.status.toLowerCase() === "pending" ? "status-pending" :
                        selectedRequest.status.toLowerCase() === "approved" ? "status-approved" :
                          selectedRequest.status.toLowerCase() === "rejected" ? "status-rejected" :
                            selectedRequest.status.toLowerCase() === "draft" ? "status-draft" :
                              selectedRequest.status.toLowerCase() === "sendback" ? "status-sendback" : ""
                        }`}>
                      {selectedRequest.status.toLowerCase() === "sendback" ? "Send Back" : selectedRequest?.status}
                    </span>
                    : "-"}

                </div>
                :
                <span className="ckr-section-title">Single client – dealer mapping</span>
              }
            </div>

            <div className="new-mapping-content">
              <div className="wrap-mapping-content upload-sec mb-20">
                <div className="internal-section wrap-file-upload dlr-full-width">
                  <label className="section-label">Attach Approval Document from Head</label>
                  {!uploadedFile && approvalDocLink === "" ?
                    <>
                      <div className="wrap-drag-drop tab-style"
                        onFocus={() => console.log("Focused")}
                        tabIndex={0}
                        role="button"
                        onClick={handleUploadClick}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleUploadClick();
                          }
                        }}>

                        <div className="upload-area">
                          <img src={attachIcon} alt="attach icon" />

                          <div className="wrap-input-cont">
                            <span className="drag-text">Click to browse or drag & drop your Excel file</span>
                            <span className="upload-info">
                              Supports .pdf, .jpg, .png or click to browse · Max 5 MB
                            </span>
                            <input
                              type="file"
                              ref={fileInputRef}
                              hidden
                              accept=".pdf,.jpg,.png"
                              id="fileUpload"
                              onChange={handleFileChange}
                              disabled={isReadOnly}

                            />
                            <label className="select-file">Select File</label>
                          </div>
                        </div>
                      </div>
                      {errors.approvalDoc && (
                        <span className="ErrorMsg">
                          {errors.approvalDoc.message}
                        </span>
                      )}
                    </>

                    :
                    <div className="dealer-doc-upload">

                      <div className="wrap-upload-section">

                        <div className="wrap-docname">
                          <img src={uploadIcon} alt="upload icon" />

                          <span className="upload-doc-btn"
                            tabIndex={0}
                            role="button"
                            onClick={handlePreviewFile}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handlePreviewFile();
                              }
                            }}
                          >
                            {uploadedFile?.name || rowData?.approvalDocFilename}
                          </span>
                        </div>

                        <img
                          className="close"
                          src={closeIcon}
                          alt="close"
                          style={{
                            cursor: isReadOnly ? "not-allowed" : "pointer",
                            pointerEvents: isReadOnly ? "none" : "auto",
                            opacity: isReadOnly ? 0.5 : 1,
                          }}
                          onClick={() => {
                            if (isReadOnly) return;

                            setUploadedFile(null);
                            setApprovalDocLink("");
                            setValue("approvalDoc", null, {
                              shouldValidate: true,
                            });

                            if (fileInputRef.current) {
                              fileInputRef.current.value = "";
                            }
                          }}
                        />

                      </div>

                    </div>
                  }
                </div>
              </div>

              <div className="wrap-mapping-content mb-20 three-col">
                <div className="internal-section">
                  <label className="section-label">UCC / Client Code <span className="error-mark">*</span></label>

                  <SearchDropdown
                    value={searchClCode}
                    placeholder="Type UCC or Client Code"
                    showDropdown={showClientDropdown}
                    setShowDropdown={setShowClientDropdown}
                    data={clientList}
                    loading={clLoader}
                    error={clError}

                    onInputChange={(e) => {
                      const input = sanitizeDropdownInput(e, {
                        allowSpace: true,
                        maxLength: 8
                      });

                      setSearchClCode(input);
                      setValue("branch", "", {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setValue("clientCode", input, {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setShowClientDropdown(true);
                      setActiveMapping(null);
                      // The old dealer belongs to the client that was selected,
                      // so it is dropped as soon as the client changes.
                      // setSearchOldDlCode("");
                      setValue("oldDealerCode", "");
                      setOldDealerName("");

                      if (!input) {
                        setClientList([]);
                        setClError("");
                        setShowClientDropdown(false);
                      }
                    }}
                    onSelect={(item) => {

                      setSearchClCode(item?.clientCode);

                      setValue(
                        "clientCode",
                        item?.clientCode,
                        {
                          shouldValidate: true,
                        }
                      );

                      setValue(
                        "branch",
                        item?.branch,
                        {
                          shouldValidate: true,
                        }
                      );

                      setClientName(item?.clientName || "");
                      setShowClientDropdown(false);
                      fetchActiveMapping(item?.clientCode);
                    }}
                    disabled={isReadOnly}
                  />

                  {/* The current mapping now has its own Old Dealer Code/Name
                      field, so only the lookup state is worth surfacing here. */}
                  {activeMappingLoader && (
                    <span className="upload-info">
                      Checking current dealer mapping...
                    </span>
                  )}

                  {errors.clientCode && (
                    <span className="ErrorMsg">
                      {errors.clientCode.message}
                    </span>
                  )}
                </div>

                <div className="internal-section">
                  <label className="section-label">New Dealer Code/Name <span className="error-mark">*</span></label>

                  <SearchDropdown
                    value={searchDlCode}
                    placeholder="Enter New Dealer Code/Name"
                    showDropdown={showDealerDropdown}
                    setShowDropdown={setShowDealerDropdown}
                    data={dealerList}
                    loading={dlLoader}
                    error={dlError}
                    onInputChange={(e) => {
                      const value = sanitizeDropdownInput(e, {
                        allowSpace: true,
                        maxLength: 50
                      });

                      setSearchDlCode(value);
                      setValue("dealerCode", value, {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                      setShowDealerDropdown(true);
                      if (!value) {
                        setDealerList([]);
                        setDlError("");
                        setShowDealerDropdown(false)
                      }
                    }}
                    onSelect={(item) => {
                      setSearchDlCode(item?.dealerCode);
                      setValue("dealerCode", item?.dealerCode, { shouldValidate: true, });
                      setDealerName(item?.dealerName || "");
                      setShowDealerDropdown(false);
                    }}
                    disabled={isReadOnly}
                  />

                  {errors.dealerCode && (
                    <span className="ErrorMsg">
                      {errors.dealerCode.message}
                    </span>
                  )}
                </div>
                {effectiveDateField}
              </div>

              <div className="wrap-mapping-content mb-20">
                {oldDealerField}

                <div className="internal-section">
                  <label className="section-label">Branch</label>
                  <input
                    className="section-input"
                    type="text"
                    placeholder="Add Branch"
                    disabled
                    value={branch || ""}
                    {...register("branch")}
                  />
                </div>
              </div>

              <div className="wrap-mapping-content mb-20">
                <div className="internal-section dlr-full-width">
                  <label className="section-label">Reason for Change<span className="error-mark">*</span></label>

                  <div className="wrap-radio-section" role="radiogroup" aria-label="reason-label">
                    <label className="radio-option">
                      <input
                        type="radio"
                        value="newMapping"
                        {...register("reasonType")}
                        onChange={handleReasonTypeChange}
                        disabled={isReadOnly}
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[0] = e;
                        }}
                      />
                      <span>New mapping</span>
                    </label>

                    <label className="radio-option">
                      <input
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[1] = e;
                        }}
                        type="radio"
                        value="updateMapping"
                        {...register("reasonType")}
                        onChange={handleReasonTypeChange}
                        disabled={isReadOnly}
                      />
                      <span>Update existing mapping</span>
                    </label>

                    <label className="radio-option">
                      <input
                        ref={(e) => {
                          register("reasonType").ref(e);
                          reasonRefs.current[2] = e;
                        }}
                        type="radio"
                        value="others"
                        {...register("reasonType")}
                        onChange={handleReasonTypeChange}
                        disabled={isReadOnly}
                      />
                      <span>Others</span>
                    </label>
                  </div>

                  {errors.reasonType && (
                    <span className="ErrorMsg">
                      {errors.reasonType.message}
                    </span>
                  )}
                  {/*
                  {selectedReasonType === "others" &&
                    <>
                      <textarea
                        ref={reasonTextareaRef}
                        maxLength={500}
                        minLength={10}
                        className="section-input textarea"
                        placeholder="Type reason here"
                        {...register("reason", {
                          required: "Reason is required"
                        })}
                        disabled={isReadOnly}
                        onChange={(e) => handleAlphaSpaceChange(e, "reason", setValue, 500)}
                        onPaste={(e) =>
                          handleAlphaSpacePaste(
                            e,
                            "reason",
                            getValues,
                            setValue,
                            500
                          )
                        }
                      />
                      <div className="char-count">
                        {pendingMinChars > 0 ? (
                          <span className="ErrorMsg">
                            Minimum {pendingMinChars} character
                            {pendingMinChars > 1 ? "s are" : " is"} required
                            ({reasonLength}/500)
                          </span>
                        ) : (
                          <span>{remainingChars} characters remaining</span>
                        )}
                      </div>
                    </>
                  }
                  */}
                </div>

              </div>

              <div className="wrap-mapping-content mb-20">
                <div className="internal-section dlr-full-width">
                  <label className="section-label">
                    Remarks <span className="error-mark">*</span>
                  </label>

                  <textarea
                    maxLength={500}
                    className="section-input textarea"
                    placeholder="Type remarks here"
                    {...register("remarks")}
                    disabled={isReadOnly}
                    onChange={(e) => handleAlphaSpaceChange(e, "remarks", setValue, 500)}
                    onPaste={(e) =>
                      handleAlphaSpacePaste(
                        e,
                        "remarks",
                        getValues,
                        setValue,
                        500
                      )
                    }
                  />

                  <div className="char-count">
                    {/* <span>{remainingRemarkChars} characters remaining</span> */}
                    {/* {pendingMinChars > 0 ? ( */}
                    {showMinCharsMsg ? (
                      // <span className="ErrorMsg">
                      //   Minimum {pendingMinChars} character
                      //   {pendingMinChars > 1 ? "s are" : " is"} required
                      //   ({remarksLength}/500)
                      // </span>
                      <span className="ErrorMsg">
                        Minimum 10 characters are required
                      </span>
                    ) : (
                      <span>{remainingRemarkChars} characters remaining</span>
                    )}
                  </div>

                  {/* The min-length message is already shown by the counter above. */}
                  {/* {errors.remarks && ( */}
                  {errors.remarks && !showMinCharsMsg && (
                    <span className="ErrorMsg">
                      {errors.remarks.message}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="mapping-footer-actions">
              {!isReadOnly ?
                <>
                  <button
                    ref={(el) => (buttonRefs.current[0] = el)}
                    onKeyDown={(e) => handleButtonKeyDown(e, 0)}
                    className={`back-btn ${!canSaveDraft || draftLoader || isReadOnly ? "disabled-btn-sec" : ""
                      }`}
                    disabled={!canSaveDraft || draftLoader || isReadOnly}
                    onClick={onSaveDraft}
                  >
                    {draftLoader ? <SmallLoader /> : "Save as Draft"}
                  </button>
                  <button
                    ref={(el) => (buttonRefs.current[1] = el)}
                    onKeyDown={(e) => handleButtonKeyDown(e, 1)}
                    className={`submit-btns ${!isValid || submitLoader || isReadOnly ? "disabled-btn" : ""
                      }`}
                    /* disabled={!isValid || !isReasonValid || submitLoader || isReadOnly} */
                    disabled={!isValid || submitLoader || isReadOnly}
                    onClick={handleSubmit(onSubmit)}
                  >
                    {submitLoader ? <SmallLoader /> : "Submit for Approval"}
                  </button>
                </>
                :
                <button className="back-btn"
                  onClick={() => setSelectedSR(null)}
                >
                  Cancel
                </button>
              }
            </div>
          </div>

          {/*
          <div className="ckr-section date-preview">
            <div className="wrap-date-cont">
              <div className="wrap-title-date">
                <span className="main-title">Date Logic Preview</span>
                <span className="grey-text">On checker approval</span>
              </div>
            </div>
            <div className="timestamp-wrap">
              {dateLogicRules.map((rule) => (
                <span key={rule.label}>
                  {rule.label} → {rule.value}
                </span>
              ))}
            </div>
          </div>
          */}
        </div>
      </div>

      <CommonModal
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        title="Confirm Request"
        className="dealer-mapping-main cdm-confirm-modal"
        backdrop="static"
        showFooter
        cancelText="Back"
        confirmText="Confirm"
        onCancel={() => setConfirmModal(false)}
        onConfirm={handleConfirmSubmit}
        confirmDisabled={submitLoader}
      >
        <div className="cdm-confirm-body">
          <div className="cdm-confirm-head">
            <span>Client Name: {clientName || confirmValues?.clientCode || "-"}</span>
            <span>Branch: {confirmValues?.branch || "-"}</span>
          </div>

          <div className="rm-comparison mb-20">
            <div className="rm-comparison-card old">
              <div className="comparison-title">OLD</div>

              <div className="comparison-row">
                <span>Dealer</span>
                <strong>
                  {/*
                  {confirmValues?.oldDealerCode && oldDealerName
                    ? `${confirmValues.oldDealerCode} ${oldDealerName}`
                    : confirmValues?.oldDealerCode ||
                      (typeof activeMapping === "string" ? activeMapping : "-")}
                  */}
                  {oldDealerLabel(confirmValues?.oldDealerCode, oldDealerName)}
                </strong>
              </div>

              <div className="comparison-row">
                <span>Branch</span>
                <strong>{confirmValues?.branch || "-"}</strong>
              </div>
            </div>

            <img src={arrowIcon} alt="arrow" />

            <div className="rm-comparison-card new">
              <div className="comparison-title">NEW</div>

              <div className="comparison-row">
                <span>Dealer</span>
                <strong>
                  {dealerName
                    ? `${confirmValues?.dealerCode} ${dealerName}`
                    : confirmValues?.dealerCode || "-"}
                </strong>
              </div>

              <div className="comparison-row">
                <span>Branch</span>
                <strong>{confirmValues?.branch || "-"}</strong>
              </div>
            </div>
          </div>

          <span className="dlr-sub-title">Reason</span>
          <input
            type="text"
            className="rm-reason-input mb-20"
            value={confirmReason}
            readOnly
            disabled
          />

          <span className="dlr-sub-title">Remarks</span>
          <input
            type="text"
            className="rm-reason-input mb-20"
            value={confirmValues?.remarks || "-"}
            readOnly
            disabled
          />

          {confirmDocName && (
            <>
              <span className="dlr-sub-title">Attachment</span>

              <div className="rm-attachment dlr-attachment">
                <div className="attachment-name">
                  <img src={uploadIcon} alt="upload icon" />
                  <span className="file-name" title={confirmDocName}>
                    {confirmDocName}
                  </span>
                </div>

                <div className="attachment-actions">
                  <button type="button" onClick={handlePreviewFile}>
                    <img src={viewIcon} alt="view" className="view-icon" />
                    <span className="btn-title">View</span>
                  </button>

                  <button type="button" onClick={handleDownloadFile}>
                    <img src={downloadIcon} alt="download" />
                    <span className="btn-title">Download</span>
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </CommonModal>
    </div>
  );
}

export default NewMappingReq;

